import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import type { DbPortalIch } from '@gql/shared-types';
import { api } from '../api/client.js';
import { useAuth } from '../auth/AuthKontext.js';

/** Löst den Link aus der E-Mail ein. Das Token steht im Fragment (#…) und erreicht daher keine Server-Protokolle. */
export function AnmeldenLink() {
  const { neuLaden } = useAuth();
  const navigate = useNavigate();
  const [fehler, setFehler] = useState<string | null>(null);
  const gestartet = useRef(false);

  useEffect(() => {
    if (gestartet.current) return;
    gestartet.current = true;
    const token = window.location.hash.replace(/^#/, '');
    // Token sofort aus Adresszeile und Verlauf entfernen
    window.history.replaceState(null, '', window.location.pathname);
    if (!/^[A-Za-z0-9_-]{43}$/.test(token)) {
      setFehler('Der Link ist unvollständig. Bitte den Link aus der E-Mail vollständig öffnen.');
      return;
    }
    api<DbPortalIch>('/anmeldung/einloesen', { methode: 'POST', json: { token } })
      .then(async (ich) => {
        await neuLaden();
        navigate(ich.nutzer?.ndaErforderlich ? '/vertraulichkeit' : '/standorte', { replace: true });
      })
      .catch((f: Error) => setFehler(f.message));
  }, [navigate, neuLaden]);

  return (
    <div className="seite seite-schmal">
      <h1>Anmeldung</h1>
      {fehler ? (
        <div className="zustand-fehler hinweis-kasten" role="alert">
          <p>{fehler}</p>
          <p>
            <Link to="/anmelden">Neuen Anmeldelink anfordern</Link>
          </p>
        </div>
      ) : (
        <p role="status">
          <span className="spinner" aria-hidden="true" /> Sie werden angemeldet …
        </p>
      )}
    </div>
  );
}
